export const MuiInputBase = {
  styleOverrides: {
    root: {
      '&.hasIcon': {
        '.MuiSelect-select.MuiInputBase-input': {
          paddingLeft: '40px',
        },
      },
      '&.hasIcon:not(.isSelected)': {
        '.MuiSelect-select.MuiInputBase-input': {
          paddingRight: '80px',
        },
      },
      '&.low .MuiSelect-select': {
        paddingTop: '8px',
        paddingBottom: '8px',
      },
    },
  },
}
